import React, { useEffect } from "react";
import { FaUsers, FaCalendarAlt, FaTasks, FaWhmcs, FaRibbon, FaChartLine, FaStopwatch, FaArrowRight } from "react-icons/fa";


import "./solutions.scss";
import { useWindowSize } from "@react-hook/window-size/throttled";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { GiChemicalDrop } from "react-icons/gi";
import StrokePattern from "../../components/stroke-pattern/stroke-pattern";
import CountUp from "react-countup";
import { HiLightBulb } from "react-icons/hi";
const Solutions = () => {
  const [width, height] = useWindowSize();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const examples = [];

  const comingSoonExamples = [
    {
      icon: <FaUsers />,
      title: "Nursing Student Placements Solution",
      firstParagraph: "A single end-to-end application accessible by education and hospital staff that includes a shared calendar and financial reporting. ",
      secondParagraph: "Streamline student placements giving maximum efficiency and clarity to all staff and students.",
      navigationLink: "/solutions/customer-relationships",
      imageLink: "/images/nursing-student-placement-platform.png",
    },
    {
      icon: <HiLightBulb />,
      title: "Innovation Platform",
      firstParagraph: `An internal crowdsourcing system that allows anyone to suggest ideas on topics or raise unique innovative ideas.`,
      secondParagraph: `Includes topic moderation, rating system, tournaments and full initiative and milestone project management system. `,
      navigationLink: `/solutions/job-management`,
      imageLink: `/images/inovation-platform-2.png`,
    },
    {
      icon: <FaCalendarAlt />,
      title: `Outpatients Room Booking`,
      firstParagraph: `Minimises vacancies and maximise patient flow.`,
      secondParagraph: `A room booking utilisation system that includes room profile management, specialties and subspecialties, room capacity, specialist booking request forms and custom dashboards.  `,
      imageLink: `/images/outpaint-booking.jpg`,
    },
    {
      icon: <GiChemicalDrop />,
      title: `Cellular Therapy
      Management System.
      `,
      firstParagraph: `From the donor eligibility statement through to the transplant consent and engraftment record, this system provides an end-to-end solution that supports the clinic, collection facility, processing and administration staff. `,
      secondParagraph: `It ensures that all clinical forms, checklists and worksheets are in one single system providing a streamlined process.`,
      imageLink: `/images/cell-therapy.jpg`,
    },
    // {
    //   icon: <FaRibbon />,
    //   title: "Compliance",
    //   firstParagraph: "Utilise checklists and document storage to stay on top of your responsibilities, ensuring all the necessary paperwork is in place.",
    //   secondParagraph: "Have access to a full history of when data is changed and by whom.",
    //   imageLink: "/images/Compliance.webp",
    // },
    // {
    //   icon: <FaWhmcs />,
    //   title: "HR Solution",
    //   firstParagraph: "Automate your back end processes, such as invoice generation, payment processing, or any other repetitive tasks.",
    //   secondParagraph: "Minimise human error with consistent reliable processing.",
    //   imageLink: "/images/Process-Automation.webp",
    // }
  ];

  return (
    <div className="Solutions full-width-element">
      <div className="topDescription app-background-text-colour">
        <img src="/images/Dotted-random-pattern.svg" className="dotted-random-pattern" />
        <section className="left">
          <h1 className="bigHeading">Solutions Made With Kzen8</h1>
          <h2 className="body">Implement solutions that utilise state of the art techonology and provide the following benefits:</h2>

          <div className="statsContainer">
            <div className="stats">
              <h1 className="header">
                <CountUp end={10} duration={0.75} />x
              </h1>
              <span className={width > 500 ? "subtitle2" : "subinfo"}>Faster development</span>
            </div>
            <div className="stats">
              <h1 className="header">
                <CountUp end={4} duration={0.25} />x
              </h1>
              <span className={width > 500 ? "subtitle2" : "subinfo"}>Resources saved</span>
            </div>
            <div className="stats">
              <h1 className="header">
                <CountUp end={3} duration={0.15} />x
              </h1>
              <span className={width > 500 ? "subtitle2" : "subinfo"}>Less downtime</span>
            </div>
          </div>
        </section>
        <section className="right"></section>
        <img src="/images/solutions-hero-image.webp" alt="solutions hero page" className="heroImage" />
      </div>

      {/* <div className="exampleSection body">
        {examples.map((example, idx) => (
          <div key={example.title} className="usageExample initially-hidden animated slideUpAnimation">
            <div className="lottieContainer" style={{ backgroundImage: `url(${example.imageLink})` }}></div>

            <div className="descriptionSection">
              <FilledPattern styles={{ position: "absolute", right: "-90px", bottom: "-40px", width: "200px" }} />
              <span className="headerSmall solutionHeader">
                {example.icon}
                <span className="primary-text">{example.title}</span>
              </span>
              <div className="description">
                <p>{example.firstParagraph}</p>
                <p>{example.secondParagraph}</p>
              </div>


            </div>
          </div>
        ))}
      </div> */}
      <div className="comingSoonSection">
        <h2 className="bigHeading comingSoonHeading"></h2>
        <h2 className="headerSmall" style={{display: 'flex', alignItems: 'center'}}>
          All of the systems shown below have been built with Kzen8
          and are available to use & configure now!
          <img src="/images/arrow-down.png" style={{width: '50px'}}/>
        </h2>
        <div className="comingSoonexampleSection body">
          {comingSoonExamples.map((example) => (
            <div key={example.title} className="usageExample initially-hidden animated slideUpAnimation cardShadow">
              <div className="headerImage" style={{ backgroundImage: `url(${example.imageLink})` }}></div>
              <div className="descriptionSection">
                {example.icon}
                <div>
                  <span className="headerSmall primary-text">{example.title}</span>
                  <div className="description">
                    <p>{example.firstParagraph}</p>
                    <p>{example.secondParagraph}</p>

                    <StrokePattern styles={{ position: "absolute", right: "-90px", bottom: "-40px", width: "200px" }} />
                  </div>

                  {/* {example.navigationLink ? (
                    <Link className="navigationLink primary-text" to={example.navigationLink}>
                      <span>
                        Learn more <FaArrowRight />
                      </span>
                    </Link>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Solutions;
